import { styled } from '@mui/material/styles';

export const StyledToolbar = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  padding: 0 24px;
  box-sizing: border-box;

  @media (max-width: 1130px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    .search-input-container {
      order: 2 !important;
      width: 100% !important;
    }
    .button-container {
      order: 1 !important;
      width: 100% !important;
    }
  }

  @media (max-width: 600px) {
    .button-container {
      flex-direction: column;
      align-items: flex-start !important;
      gap: 8px;
    }
    .button-action {
      width: 100% !important;
    }
  }

  /* New layout with feature flag */
  &.toolbar-new-api-launch {
    @media (max-width: 768px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;

      .search-input-container {
        order: 2 !important;
        width: 100% !important;
      }

      .button-container {
        order: 1 !important;
        width: 100% !important;
        display: flex;
        flex-direction: row;
      }

      .button-faq.MuiButton-root {
        border: none !important;
        background: transparent !important;
        min-width: auto !important;
        padding: 8px !important;
      }
    }
  }
`;
